<ul>
    <li *ngFor='let spud of spuds' ><app-spud [spud]="spud"></app-spud></li>
</ul>
